import { call, put, takeLatest } from 'redux-saga/effects';

import { CancerQuote } from '@models/CancerQuote';
import { CancerQuoteApi } from '@apis/CancerQuoteApi';
import { history } from '@utils/history';
import { SagaPayload } from '@utils/typescript';
import { BillingApi } from '@apis/BillingApi';
import { Billing } from '@models/Billing';
import { routeCancerQuotePaymentPage } from '@components/CancerQuotePaymentPage';

import {
  cancerQuoteFind,
  CancerQuoteFindPayload,
  cancerQuoteCreate,
  CancerQuoteCreatePayload,
  cancerQuoteFetch,
  CancerQuoteFetchPayload,
  cancerQuoteUpdate,
  CancerQuoteUpdatePayload,
  cancerQuoteCustom,
  CancerQuoteCustomPayload,
  cancerQuotePay,
  CancerQuotePayPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';
import { routeCancerQuoteBuyReviewPage } from './route';

function* handleCancerQuoteFind({ payload }: SagaPayload<CancerQuoteFindPayload>) {
  const state: StateUpdatePayload = { cancerQuote: null };
  try {
    state.cancerQuote = (yield call(CancerQuoteApi.find, payload)) as CancerQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleCancerQuoteCreate({ payload }: SagaPayload<CancerQuoteCreatePayload>) {
  const state: StateUpdatePayload = { cancerQuote: null };
  try {
    state.cancerQuote = (yield call(CancerQuoteApi.create, payload)) as CancerQuote;
    yield put(stateUpdate(state));
    history.navigate(routeCancerQuoteBuyReviewPage({ orderNumber: state.cancerQuote.orderNumber }));
  } catch { }
}

function* handleCancerQuoteFetch({ payload }: SagaPayload<CancerQuoteFetchPayload>) {
  const state: StateUpdatePayload = { cancerQuote: null };
  try {
    state.cancerQuote = (yield call(CancerQuoteApi.get, payload)) as CancerQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleCancerQuoteUpdate({ payload }: SagaPayload<CancerQuoteUpdatePayload>) {
  const state: StateUpdatePayload = { cancerQuote: null };
  try {
    state.cancerQuote = (yield call(CancerQuoteApi.update, payload)) as CancerQuote;
    yield put(stateUpdate(state));
    history.navigate(routeCancerQuoteBuyReviewPage({ orderNumber: state.cancerQuote.orderNumber }));
  } catch { }
}

function* handleCancerQuoteCustom({ payload }: SagaPayload<CancerQuoteCustomPayload>) {
  const state: StateUpdatePayload = { cancerQuote: null };
  try {
    state.cancerQuote = (yield call(CancerQuoteApi.custom, payload)) as CancerQuote;
    yield put(stateUpdate(state));
    history.navigate(routeCancerQuoteBuyReviewPage({ orderNumber: state.cancerQuote.orderNumber }));
  } catch { }
}

function* handleCancerQuotePay({ payload }: SagaPayload<CancerQuotePayPayload>) {
  try {
    const { id } = (yield call(BillingApi.create, payload)) as Billing;
    history.navigate(routeCancerQuotePaymentPage({ orderNumber: payload.orderNumber, billingId: id }));
  } catch { }
}

export default function* () {
  yield takeLatest(cancerQuoteFind, handleCancerQuoteFind);
  yield takeLatest(cancerQuoteCreate, handleCancerQuoteCreate);
  yield takeLatest(cancerQuoteFetch, handleCancerQuoteFetch);
  yield takeLatest(cancerQuoteUpdate, handleCancerQuoteUpdate);
  yield takeLatest(cancerQuoteCustom, handleCancerQuoteCustom);
  yield takeLatest(cancerQuotePay, handleCancerQuotePay);
}
